<template>
  <div class="marquee-container">
    <div class="marquee-content">
      <span class="marquee-text">{{ message }}</span>
      <!-- 复制一次内容做无缝滚动 -->
      <span class="marquee-text">{{ message }}</span>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
export default {
  name: "MarqueeNotice",
  props: {
    message: {
      type: String,
      default: i18n.t("welcome.register_trial_description")
    },
    duration: {
      // 滚动一轮所需时间，单位秒
      type: Number,
      default: 5
    }
  }
};
</script>

<style scoped>
.marquee-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  background-color: rgba(255, 255, 255, 0.15); /* 可根据你设计调背景 */
  padding: 8px 0;
}

.marquee-content {
  display: inline-block;
  /* 两倍宽度，以便内容滚出时后面接上复制内容 */
  /* animation 的 translateX 从 0 到 -50% 或 -100% 看内容布局 */
  animation: marqueeMove linear infinite;
}

.marquee-text {
  display: inline-block;
  padding: 0 2rem;
  font-size: 16px;
  color: #333;
  /* 可加渐变 / 文字样式等 */
}

/* keyframes 动画：从 0 到 -50% （向左移动一半内容） */
@keyframes marqueeMove {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 动态动画时长 */
.marquee-content {
  animation-duration: var(--marquee-duration, 8s);
}
</style>
